/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import moment from 'moment';
import { dispatchClearNDCDetailReduxData } from '../../AccRecNDCDetail/store/actions';

export const setNDCActivityHeader = (val) => {
  return { type: actiontypes.ACC_REC_NDC_ACTIVITY_HEAD, payload: val };
};

export const setNDCActivityResponse = (val) => {
  return { type: actiontypes.ACC_REC_NDC_RESPONSE, payload: val };
};

export const ndcActivityFirstLoadAction = (val) => {
  return { type: actiontypes.NDC_ACTIVITY_FIRST_LOAD, payload: val };
};

export const getAcctRecvbyQtrNDCActivity = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_QTR_NDC_ACTIVITY}`, val)
    .then((response) => {
      dispatch(setNDCActivityResponse(response.data));
      let rec = response.data.acctRecvbyQtrNdcActivityResponse || [];
      rec = rec.map((ob) => {
        ob.activityDt = ob.activityDt
          ? moment(ob.activityDt).format('MM/DD/YYYY')
          : ob.activityDt;
        ob.uraChange =
          ob.uraChange != null
            ? Number(ob.uraChange).toFixed(4)
            : parseFloat(0).toFixed(4);
        ob.activityUnits =
          ob.activityUnits != null
            ? Number(ob.activityUnits).toFixed(4)
            : parseFloat(0).toFixed(4);
        ob.unitRebateOffsetAmt = ob.unitRebateOffsetAmt
          ? Number(ob.unitRebateOffsetAmt).toFixed(4)
          : parseFloat(0).toFixed(4);
        ob.roaChangeAmt = ob.roaChangeAmt
          ? `$ ${ob.roaChangeAmt}`
          : `$ ${parseFloat(0).toFixed(2)}`;
        ob.acivityURA =
          ob.acivityURA != null
            ? Number(ob.acivityURA).toFixed(4)
            : parseFloat(0).toFixed(4);
        return ob;
      });
      dispatch({
        type: actiontypes.ACC_REC_NDC_ACTIVITY,
        payload: rec,
      });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.ACC_REC_NDC_ACTIVITY, payload: [] });
      dispatch(setNDCActivityResponse(null));
    });
};

export const activityTypePrincipal = (val) => {
  return { type: actiontypes.ACTIVITY_TYPE_PRINCIPAL, payload: val };
};

export const activityTypeInterest = (val) => {
  return { type: actiontypes.ACTIVITY_TYPE_INTEREST, payload: val };
};

export const dispatchClearNDCActivityReduxData = (val) => {
  return {
    type: actiontypes.ACCOUNT_REC_NDC_ACTIVITY_CLEAR_REDUX,
    payload: val,
  };
};

export const clearAccountRecNDCActivityPage =
  (history) => (dispatch, getState) => {
    // const reduxObj = getState()?.sharedState?.AccRecNDCDetailReducer;
    // const reduxObj1 = getState()?.sharedState?.AccRecNDCActivityReducer;
    // const updateTabs =
    //   JSON.parse(localStorage.getItem('tabItemsData')) === null
    //     ? []
    //     : JSON.parse(localStorage.getItem('tabItemsData'));
    // let changePass = false;
    // let newObj1 = {};
    // let nObj1 = {};
    // if (!_.isEmpty(updateTabs)) {
    //   const newObj = _.cloneDeep(reduxObj);
    //   const nObj = _.cloneDeep(reduxObj1);
    //   if (
    //     updateTabs.filter((x) => x.navTo === '/AccRecNDCDetail').length === 0
    //   ) {
    //     nObj1 = {
    //       activity_type_principal: false,
    //       activity_type_interest: false,
    //     };
    //     newObj1 = { modificationFromAr: [] };
    //     changePass = true;
    //   } else {
    //     nObj1.ndc_activity_response = reduxObj1.ndc_activity_response;
    //   }
    // } else {
    //   changePass = true;
    //   nObj1 = {
    //     activity_type_principal: false,
    //     activity_type_interest: false,
    //   };
    //   newObj1 = { modificationFromAr: [] };
    // }
    // if (changePass) {
    //   dispatch(dispatchClearNDCDetailReduxData(newObj1));
    // }
    dispatch(dispatchClearNDCActivityReduxData());
  };
